import { forwardRef, useImperativeHandle, useState } from "react";

import { Checkbox } from "primereact/checkbox";

import "./CheckboxDoNotShowAgain.scss";

export type CheckboxHandle = {
  isChecked: () => boolean;
};

interface ICheckboxProps {
  inputId: string;
  checkedByDefault?: boolean;
  label?: React.ReactNode;
}

// Exposes a method to get the checked status via ref since the popup is created dynamically
// Solves the issue of reading the correct checkbox state from parent
// that is caused by the behavior of confirmPopup which mounts the content into an isolated DOM tree and it will not re-render that content in response to parent state updates)
const CheckboxDoNotShowAgain = forwardRef<CheckboxHandle, ICheckboxProps>(
  ({ inputId, checkedByDefault = false, label }, ref) => {
    const [checked, setChecked] = useState<boolean>(checkedByDefault);

    // exposes a small API so parent can read final value
    useImperativeHandle(
      ref,
      () => ({
        isChecked: () => checked,
      }),
      [checked],
    );

    return (
      <div className="checkbox-container">
        <Checkbox inputId={inputId} checked={checked} onChange={e => setChecked(Boolean(e.checked))} />
        <label htmlFor={inputId}>{label}</label>
      </div>
    );
  },
);

CheckboxDoNotShowAgain.displayName = "CheckboxDoNotShowAgain";

export default CheckboxDoNotShowAgain;
